import * as _ from 'lodash'
import {ICell, ICellMetricUOM, ICubeSource} from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import {BehaviorSubject} from "rxjs/Rx";
import {WB_SimulationInputRelationshipRow, WB_SimulationPredictorRelationshipRow} from "../PA.Core/PAdbSchemaRows";
import {DimensionType} from "../PA.Core/PA.Core.IF.Hierarchy";

export class SimulationPredictorInputCell
    implements ICell
{
    private _onCellChange: BehaviorSubject<{ Cell: ICell; MetricIds?: string[] }>
    private _cubeSource: ICubeSource
    private _predictorRelRow: WB_SimulationPredictorRelationshipRow
    private _inputRelRow: WB_SimulationInputRelationshipRow
    private _bMetricValuesLoaded: boolean
    private _cellId: string
    private _productGroupId: string
    private _periodId: string

    constructor(cubeSource:                  ICubeSource,
                aSimulatorPredictorRelRow:   WB_SimulationPredictorRelationshipRow,
                aSimulatorInputRelRow:       WB_SimulationInputRelationshipRow)
    {
        this._cubeSource      = cubeSource
        this._predictorRelRow = aSimulatorPredictorRelRow
        this._inputRelRow     = aSimulatorInputRelRow
        this._onCellChange    = new BehaviorSubject<{Cell: ICell; MetricIds?: string[]}>(undefined)

        this._cellId =  (this._predictorRelRow?.cif?.WB_SIMULATION_PREDICTORR_ID || 'na') + '-' +
                        (this._inputRelRow?.cif?.WB_SIMULATION_INPUTR_ID || 'na')

        // Should we check the keys (WB_PRDGRP_ID, WB_PERIOD_ID) are the same between the two rows
        this._productGroupId = this._predictorRelRow.cif.WB_PRDGRP_ID + ''
        this._periodId = this._predictorRelRow.cif.WB_PERIOD_ID + ''

        this._bMetricValuesLoaded = true
    }

    get CellId(): string { return this._cellId }
    get bCellEnabled(): boolean { return true };

    get OnCellChange(): BehaviorSubject<{ Cell: ICell; MetricIds?: string[] }> {
        return this._onCellChange
    }

    get bMetricValuesLoaded(): boolean {  return this._bMetricValuesLoaded }

    getCellMetricValue(metricId: string): string | number {
        let metric = this._cubeSource.getMetric(metricId)
        if(_.isEmpty(metric)){
            console.log("Unknown Metric: ", metricId)
            return 0
        }

        switch (metric.Options?.Type){
            case "ModelPredictor":
                // @ts-ignore
                return this._predictorRelRow[metricId]

            case "SimulationInput":
                // @ts-ignore
                return this._inputRelRow[metricId]
        }

        return 0

    }

    getCellMetricUOM(metricId: string): ICellMetricUOM {
        return undefined;
    }

    getKey(dimensionTypeId: string): string {

        switch (dimensionTypeId){
            case DimensionType.Product:
                return this._productGroupId

            case DimensionType.Time:
                return this._periodId
        }
        return ""
    }

    getKeys(): {[dimTypeId: string]: string} {
        return {[DimensionType.Product]: this._productGroupId,
                [DimensionType.Time]:    this._periodId};
    }

    refreshMetricValues(): Promise<void> | void {
        //-- Nothing to do here
        this._bMetricValuesLoaded = true
        return;
    }

    setCellMetricValue(MetricId: string, value: number | string): void {
        let metric = this._cubeSource.getMetric(MetricId)
        if(_.isEmpty(metric)){
            console.log("Unknown Metric: ", MetricId)
        }

        if(metric.bIsReadOnly)
            return

        let newValue = _.toNumber(value)
        if(!_.isNumber(newValue))
            return

        switch (metric.Options?.Type){
            case "ModelPredictor":
                // @ts-ignore
                this._predictorRelRow[MetricId] = newValue
                break;

            case "SimulationInput":
                // @ts-ignore
                this._inputRelRow[MetricId] = newValue
                break;
        }

        this.OnCellChange.next({Cell: this, MetricIds: [MetricId]})

    }

    rowsMatch(aSimPredictor:   WB_SimulationPredictorRelationshipRow,
              aSimInput:       WB_SimulationInputRelationshipRow): boolean
    {
        if(this._predictorRelRow?.cif?.WB_SIMULATION_PREDICTORR_ID != aSimPredictor?.cif?.WB_SIMULATION_PREDICTORR_ID)
            return false

        if(this._inputRelRow?.cif?.WB_SIMULATION_INPUTR_ID != aSimInput?.cif?.WB_SIMULATION_INPUTR_ID)
            return false

        return true
    }

}